import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: "FloorplanSwitcher",
  templateUrl: './floorplan-switcher.component.html',
  styleUrls: ['./floorplan-switcher.component.scss'],
})
export class FloorplanSwitcher implements OnInit, OnDestroy, OnChanges  {

  @Input() icon: string;
  @Input() text: string;
  @Input() items: any; // [{text: ..., value: ...}, ...s]
  @Input() selected: any[] = [];
  @Input() locked: any[] = [];
  @Input() onChange: any;
  public open: boolean = false;
  public search: string = "";
  public filteredItems: any[] = [];
  public selectedItems: string[] = [];
  public selectedValues: string[] = [];
  public lockedItems: any[] = [];

  public selectedFloorplanName: string = 'First floor';

  public floorplan;
  public floorplanId;
  public showEditFloorplanModal: boolean = false;

  constructor() {
    this.changeSelect = this.changeSelect.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  ngOnInit(){
  }

  ngAfterViewInit(){
  }

  ngOnDestroy(){
  }


  public openEditFloorplanModal(floorplanId, floorplan){
    this.showEditFloorplanModal = true;

    if(floorplanId){
      this.floorplanId = floorplanId;
      this.floorplan = floorplan;
    }
  }

  public closeEditFloorplanModal(){
    this.showEditFloorplanModal = false;
  }

  // --------------- NEEDS UPDATING TO FLOORPLANS: --------------- //

  ngOnChanges(changes: SimpleChanges) {
    if(changes.items){
      this.filteredItems = this.filterByName(changes.items.currentValue, this.search);
    }
    if(changes.selected) {
      if(changes.selected.currentValue) {
        this.selectedItems = changes.selected.currentValue;
      } else {
        this.selectedItems = [];
      }
    }

    if(changes.locked) {
      if(changes.locked.currentValue) {
        this.lockedItems = changes.locked.currentValue;
      } else {
        this.lockedItems = [];
      }
    }
  }

  filterByName(items, search){
    if(search == "") {
      return items;
    }
    return items.filter(i => i.text.includes(search));
  }

  changeSearch(event) {
    const { value } = event.target;
    this.search = value;
    this.filteredItems = this.filterByName(this.items, this.search);
  }

  isSelected(value){
    return this.selectedItems.filter(s => s === value).length > 0;
  }

  isLocked(value){
    return this.lockedItems.filter(s => s.value === value).length > 0;
  }

  isLockedName(value){
    const item = this.lockedItems.find(s => s.value === value);
    if(item){
      return item.text;
    }
    return "";
  }

  // @FIXME: deselect item when radio is unchecked
  changeSelect(value, event) {
    const { checked } = event.target;
    if (checked) {
      // add it
      this.selectedItems.push(value);
      // make unique
      this.selectedItems = this.selectedItems.filter((item, i, ar) => ar.indexOf(item) === i);
    } else {
      //remove it
      this.removeOccurrences(this.selectedItems, value);
    }
    // Reiterate over selectedValues.
    this.selectedValues = this.selectedItems.map(i => {
      const item = this.items.find(i2 => i2.value === i)
      if(item){
        return item.text;
      }
    })
    this.onChange(this.selectedItems);
  }

  toggleDropdown(){
    this.open = !this.open;
  }

  identify(index, item){
    return item.value;
  }

  removeOccurrences(array, item) {
    var i = array.length;
    while (i--) {
      if (array[i] === item) {
        array.splice(array.indexOf(item), 1);
      }
    }
  }

}
